// ----------------------------------------------------------------------
// Campaign Management Translations - French
// ----------------------------------------------------------------------

export const campaignFr = {
  campaign: {
    title: 'Suivi des Campagnes',
    subtitle: 'Créez des liens UTM pour suivre vos campagnes sur les réseaux sociaux',
    activeCampaigns: 'actives',
    createNew: 'Créer une Campagne',
    viewDetails: 'Voir les Détails',
    hideDetails: 'Masquer les Détails',
    urlCopied: 'Lien de suivi copié',
    utmParameters: 'Paramètres UTM',
    defaultMedium: 'Medium par défaut',

    // Create Form
    create: {
      title: 'Créer une Nouvelle Campagne',
      description: 'Générez un lien de suivi unique pour votre campagne sur les réseaux sociaux',
      submit: 'Créer la Campagne',
    },

    // Form Fields
    field: {
      name: 'Nom de la Campagne',
      namePlaceholder: 'ex., Promo Instagram Fête d\'été',
      nameHelp: 'Un nom descriptif pour votre campagne',
      description: 'Description',
      descriptionPlaceholder: 'Brève description de votre campagne...',
      platform: 'Plateforme',
      contentType: 'Type de Contenu',
      trackingUrl: 'URL de Suivi',
      budget: 'Budget',
      targetClicks: 'Objectif de Clics',
      targetConversions: 'Objectif de Conversions',
      notes: 'Notes',
      notesPlaceholder: 'Notes supplémentaires sur cette campagne...',
      tags: 'Tags',
      tagsPlaceholder: 'été, promo, instagram',
      tagsHelp: 'Tags séparés par des virgules pour organiser les campagnes',
    },

    // Content Types
    contentType: {
      post: 'Publication',
      story: 'Story',
      reel: 'Reel',
      video: 'Vidéo',
      carousel: 'Carrousel',
      ad: 'Publicité',
      email: 'Email',
      sms: 'SMS',
      live: 'Live',
      other: 'Autre',
    },

    // Statuses
    status: {
      draft: 'Brouillon',
      active: 'Active',
      paused: 'En Pause',
      completed: 'Terminée',
      archived: 'Archivée',
    },

    // Table Headers
    table: {
      campaign: 'Campagne',
      platform: 'Plateforme',
      status: 'Statut',
      clicks: 'Clics',
      conversions: 'Conversions',
      revenue: 'Revenu',
      conversionRate: 'Taux Conv.',
      actions: 'Actions',
    },

    // Actions
    action: {
      copyLink: 'Copier le Lien de Suivi',
      edit: 'Modifier',
      activate: 'Activer',
      pause: 'Mettre en Pause',
      resume: 'Reprendre',
      complete: 'Marquer Terminée',
      delete: 'Supprimer',
    },
    actions: 'Actions',

    // Tabs
    tab: {
      campaigns: 'Campagnes',
      analytics: 'Statistiques',
    },

    // Empty State
    empty: {
      title: 'Aucune campagne',
      description: 'Créez votre première campagne pour commencer à suivre vos performances',
      cta: 'Créer Votre Première Campagne',
    },

    // Validation
    validation: {
      nameMin: 'Le nom de la campagne doit contenir au moins 3 caractères',
      nameMax: 'Le nom de la campagne ne doit pas dépasser 100 caractères',
      nameRequired: 'Le nom de la campagne est requis',
      descriptionMax: 'La description ne doit pas dépasser 500 caractères',
      platformRequired: 'La plateforme est requise',
      contentTypeRequired: 'Le type de contenu est requis',
    },

    // Success Messages
    success: {
      created: 'Campagne créée avec succès',
      updated: 'Campagne mise à jour avec succès',
      deleted: 'Campagne supprimée avec succès',
      statusUpdated: 'Statut de la campagne mis à jour',
    },

    // Error Messages
    error: {
      createFailed: 'Échec de la création de la campagne',
      updateFailed: 'Échec de la mise à jour de la campagne',
      deleteFailed: 'Échec de la suppression de la campagne',
      statusUpdateFailed: 'Échec de la mise à jour du statut',
      loadFailed: 'Échec du chargement des campagnes',
    },

    // Analytics
    analytics: {
      error: 'Échec du chargement des statistiques',
      totalCampaigns: 'Total Campagnes',
      active: 'actives',
      totalClicks: 'Total Clics',
      uniqueVisitors: 'visiteurs uniques',
      totalConversions: 'Conversions',
      conversionRate: 'taux de conversion',
      totalRevenue: 'Revenu Total',
      platformPerformance: 'Performance par Plateforme',
      contentTypePerformance: 'Performance par Type de Contenu',
      topCampaigns: 'Meilleures Campagnes',
      campaigns: 'campagnes',
      clicks: 'Clics',
      conversions: 'Conversions',
      conv: 'Conv.',
      revenue: 'Revenu',
    },
  },
};

export default campaignFr;
